import ListingDetails from "../common/ListingDetails";
import useListingDetails from "../../hooks/useListingDetails";
import {
  InfoText,
  formatPhoneNumber,
} from "../common/PropertySummary";
import { formatDate } from "../../utils/dates";
import DetailsField from "./DetailsField";
import { formatCurrency } from "../../utils/numbers";
import { EnumProductTypes, Listing } from "src/types/listing";
import { formatAddressWithFallbacks } from "src/utils/neighborhoodSearch";
import { useNotesTagsDialogs } from "src/hooks/useNotesTagsDialogs";
import SectionHeader from "../listingDetails/SectionHeader";
const ExpiredDetails = ({
  productType,
  isOld = false,
  listingId,
  isHideDNCPhoneNumbers,
}: {
  productType: EnumProductTypes;
  isOld: boolean;
  listingId: string;
  isHideDNCPhoneNumbers?: boolean;
}) => {
  const { setIsManageNotesOpen, setIsManageTagsOpen, isManageNotesOpen, isManageTagsOpen } =
    useNotesTagsDialogs();

  const {
    listing,
    isLoading,
    isError,
    handleTagsSaveClick,
    handleAddNoteClick,
    handleDeleteNoteClick,
    handleToggleContactIsDisabled
  } = useListingDetails({
    listingId,
    productType,
    isHideDNCPhoneNumbers,
    onTagsSaved: () => {
      setIsManageTagsOpen(false);
    },
  });

  return (
    <ListingDetails
      listingId={listingId}
      setIsManageNotesOpen={setIsManageNotesOpen}
      setIsManageTagsOpen={setIsManageTagsOpen}
      isManageNotesOpen={isManageNotesOpen}
      isManageTagsOpen={isManageTagsOpen}
      listing={listing as Listing}
      isLoading={isLoading}
      isError={isError}
      onSaveTagsClick={handleTagsSaveClick}
      onAddNoteClick={handleAddNoteClick}
      onDeleteNoteClick={handleDeleteNoteClick}
      onToggleContactIsDisabled={handleToggleContactIsDisabled}
      PropertyDetailsProps={{
        customSection1Content: listing && (
          <div className="flex gap-4 flex-wrap items-center">
            <InfoText
              title={"Price"}
              info={listing?.price ? formatCurrency(listing?.price) : "--"}
            />
            <InfoText title="DOM" info={listing?.daysOnMarket} />
            <InfoText title="Landvoice ID" info={listing?.id} />
            <InfoText
              title="Date Processed"
              info={formatDate(listing?.publishDate)}
            />
          </div>
        ),
      }}
    >
      {!isLoading && !isError && (
        <>
          <div className=" flex flex-col gap-12 mt-12 print:mt-2 print:gap-3">
            <section>
              <div>
                <SectionHeader title="MLS Information" />
                <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-3">
                  <DetailsField
                    fieldLabel="MLS ID"
                    fieldValue={listing?.mlsNumber}
                  />
                  <DetailsField
                    fieldLabel="Status"
                    fieldValue={listing?.status}
                  />
                  <DetailsField
                    fieldLabel="Status Date"
                    fieldValue={formatDate(listing?.statusDate)}
                  />
                  <DetailsField
                    fieldLabel="Agent"
                    fieldValue={listing?.listAgent}
                  />
                  <DetailsField
                    fieldLabel="Phone"
                    fieldValue={formatPhoneNumber(listing?.listAgentPhone)}
                  />
                  <DetailsField
                    fieldLabel="Company"
                    fieldValue={listing?.listAgentCompany}
                  />
                </div>
              </div>
            </section>

            <section>
              <div>
                <SectionHeader title="Tax Information" />
                <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-3">
                  <DetailsField
                    fieldLabel="Owner Name"
                    fieldValue={`${listing?.ownerContactInfo?.fullName}`}
                    noValueDisplay="Owner not found"
                  />
                  <DetailsField
                    fieldLabel="Phone Number"
                    fieldValue={listing?.ownerContactInfo?.phone}
                    noValueDisplay="Owner number not found"
                  />
                  <DetailsField
                    fieldLabel="Mailing Address"
                    fieldValue={formatAddressWithFallbacks(listing?.ownerContactInfo?.address, {
                      fallbackText: ""
                    })}
                    noValueDisplay="Owner address not found"
                  />
                  <DetailsField
                    fieldLabel="Tax ID"
                    fieldValue={listing?.taxId}
                    noValueDisplay="Tax ID not found"
                  />
                  <DetailsField
                    fieldLabel="Owner Occupied"
                    fieldValue={listing?.ownerOccupied ? "Yes" : "No"}
                    noValueDisplay=""
                  />
                </div>
              </div>
            </section>
            <section>
              <div>
                <SectionHeader title="Agent Remarks from MLS" />
                <p className="text-[14px] text-gray-primary leading-[21px] print:text-[10px] print:leading-3 ">
                  {listing?.comments}
                </p>
              </div>
            </section>

            <section>
              <div>
                <SectionHeader title="Showing Instructions" />
                <p className="text-[14px] leading-[21px] print:text-[10px] print:leading-3 ">
                  {listing?.showingInstructions}
                </p>
              </div>
            </section>
          </div>
        </>
      )}
    </ListingDetails>
  );
};

export default ExpiredDetails;
